import { render, staticRenderFns } from "./ExamRecord.vue?vue&type=template&id=32df7aaa&scoped=true"
import script from "./ExamRecord.vue?vue&type=script&lang=js"
export * from "./ExamRecord.vue?vue&type=script&lang=js"
import style0 from "./ExamRecord.vue?vue&type=style&index=0&id=32df7aaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32df7aaa",
  null
  
)

export default component.exports